export type ComputedRange = {
  seasonYear: number
  startDate: string
  endDate: string
}

const DAY_IN_MS = 86_400_000

export function dayBefore(date: string): string {
  const [year, month, day] = date.split('-').map((part) => Number.parseInt(part, 10))
  return new Date(Date.UTC(year, month - 1, day) - DAY_IN_MS).toISOString().slice(0, 10)
}

export function isValidAnchor(anchorMonth: number, anchorDay: number): boolean {
  if (anchorMonth < 1 || anchorMonth > 12) return false
  if (anchorDay < 1 || anchorDay > 31) return false
  if (anchorMonth === 2 && anchorDay > 28) return false
  if (
    (anchorMonth === 4 || anchorMonth === 6 || anchorMonth === 9 || anchorMonth === 11) &&
    anchorDay > 30
  ) {
    return false
  }
  return true
}

export function seasonYearFor(date: string, anchorMonth: number, anchorDay: number): number {
  const [year, month, day] = date.split('-').map((part) => Number.parseInt(part, 10))
  const atOrAfterAnchor =
    month > anchorMonth || (month === anchorMonth && day >= anchorDay)
  return atOrAfterAnchor ? year : year - 1
}

export function computeRange(
  seasonYear: number,
  anchorMonth: number,
  anchorDay: number,
): ComputedRange {
  return {
    seasonYear,
    startDate: `${seasonYear}-${pad(anchorMonth)}-${pad(anchorDay)}`,
    endDate: `${seasonYear + 1}-${pad(anchorMonth)}-${pad(anchorDay)}`,
  }
}

export function currentSeasonYear(today: string, anchorMonth: number, anchorDay: number): number {
  return seasonYearFor(today, anchorMonth, anchorDay)
}

export function recentSeasonYears(
  today: string,
  anchorMonth: number,
  anchorDay: number,
  count = 4,
): number[] {
  const current = currentSeasonYear(today, anchorMonth, anchorDay)
  return Array.from({ length: count }, (_, i) => current - i)
}

function pad(value: number): string {
  return value.toString().padStart(2, '0')
}
